<template>
  <HkiaraceBannerFrame :label="$t('header.pricing_info')">
    <v-container class="pricing-info-content">
      <div class="pricingTitle">
        <strong>機場員工會所設施收費表</strong>
      </div>
      <div class="pricingTitle">
        <strong>Rental Fee of HKIA Staff Clubhouse Facilities</strong>
      </div>
      <table border="1" width="100%" class="pricingContainer">
        <tbody>
        <tr>
          <td style="width: 10%;" rowspan="3" colspan="1">
            <p style="text-align: center;"><strong>設施項目</strong></p>
            <p style="text-align: center;"><strong>Facilities</strong></p>
          </td>
          <td style="text-align: center; width: 40%;" colspan="4">
            <p><strong>收費</strong></p>
            <p><strong>Charges</strong></p>
          </td>
          <td style="text-align: center; width: 10%;" rowspan="3" colspan="1">
            <p><strong>服務時間</strong></p>
            <p><strong>Service Hours</strong></p>
          </td>
          <td style="text-align: center; width: 40%;" rowspan="3" colspan="4">
            <p><strong>備註</strong></p>
            <p><strong>Remarks</strong></p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td style="width: 20%;" colspan="2">
            <p><strong>非繁忙時間</strong></p>
            <p><strong>Non-peak Hours</strong></p>
          </td>
          <td style="width: 20%;" colspan="2">
            <p><strong>繁忙時間</strong></p>
            <p><strong>Peak Hours</strong></p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td colspan="2">
            <p><strong>星期一至星期五</strong></p>
<!--            <p><strong>上午 7:30 至 正午 12:00</strong></p>-->
<!--            <p><strong>下午 2:00 至 下午 6:00</strong></p>-->
            <p><strong>星期六，日及公眾假期 (全日)</strong></p>

            <p><strong>Mondays to Fridays</strong></p>
<!--            <p><strong>7:30am to 12:00nm</strong></p>-->
<!--            <p><strong>2:00pm to 6:00pm </strong></p>-->
            <p><strong>Saturdays, Sundays and Public Holidays (full day)</strong></p>

            <p><strong>07:30 - 12:00</strong></p>
            <p><strong>14:00 - 18:00</strong></p>
          </td>
          <td colspan="2">
            <p><strong>星期一至星期五</strong></p>
<!--            <p><strong>正午 12:00 至 下午 2:00</strong></p>-->
<!--            <p><strong>下午 6:00 至 晚上 10:00</strong></p>-->

            <p><strong>Mondays</strong><strong> to Fridays</strong></p>
<!--            <p><strong>12:00nn to 2:00pm</strong></p>-->
<!--            <p><strong>6:00pm to 10:00pm</strong></p>-->
            <p><strong>12:00 - 14:00</strong></p>
            <p><strong>18:00 - 22:00</strong></p>
          </td>
        </tr>
        <tr style="text-align: center; height: 81px;">
          <td style="height: 81px;" colspan="1">
            <p>健身室</p>
            <p>Gymnasium</p>
          </td>
          <td style="height: 81px;" colspan="4">
            <p>$40 / 次 Entry</p>
            <p>320 / 月票 Monthly Pass</p>
            <p>$2,900 / 年票 Annual Pass</p>
          </td>
          <td style="height: 81px;" colspan="1">
            <p>07:30-22:30</p>
          </td>
          <td style="text-align: left; height: 81px;" colspan="4">
            <p>使用者必須穿著整齊運動服裝及不脫色運動鞋</p>
            <p>Users must be in appropriate sports attires and wear non-marking sports rubber shoes</p>
          </td>
        </tr>
        <tr style="text-align: center; height: 65px;">
          <td style="height: 65px;">
            <p>休息室</p>
            <p>Relaxation Room</p>
          </td>
          <td style="height: 65px;" colspan="4">
            <p>$20 / 2 小時 hours (06:00-00:00)</p>
            <p>$50 / 節 session (00:00-06:00)</p>
          </td>
          <td style="height: 65px;" colspan="1">
            <p>24 小時 / Hours</p>
          </td>
          <td style="height: 65px;" colspan="4">
            <p style="text-align: left;">每節最多只可容納12人使用</p>
            <p style="text-align: left;">The maximum capacity of each session is 12.</p>
          </td>
        </tr>
        <tr style="text-align: center; height: 62px;">
          <td style="height: 62px;">
            <p>卡拉 OK 室</p>
            <p>Karaoke Room</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$100 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$150 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
          <td style="height: 62px;" colspan="4">
            <p style="text-align: left;">卡拉OK室最多只可容納6人使用</p>
            <p style="text-align: left;">The maximum capacity of the Karaoke Room is 6.</p>
          </td>
        </tr>
        <tr style="text-align: center; height: 62px;">
          <td style="height: 62px;" colspan="1">
            <p>閱讀室</p>
            <p>Quiet Room</p>
          </td>
          <td style="height: 62px;" colspan="4">
            <p>免費</p>
            <p>Free of Charge</p>
          </td>
          <td style="height: 62px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
          <td style="height: 62px;" colspan="4">
            <p style="text-align: left;">每節最多只可容納6人使用</p>
            <p style="text-align: left;">The maximum capacity of each session is 6.</p>
          </td>
        </tr>
        <tr style="text-align: center; height: 62px;">
          <td style="height: 62px;" colspan="1" rowspan="2">
            <p>網球場</p>
            <p>Tennis Court</p>
          </td>
            <td colspan="2">
              <p><strong>星期一至星期五</strong></p>
              <p><strong>Mondays to Fridays</strong></p>
              <p><strong>13:00 - 18:00<br><br></strong></p>

              <p><strong>星期六，日及公眾假期 (全日)</strong></p>
              <p><strong>Saturdays, Sundays and Public Holidays (full day)</strong></p>

              <p><strong>13:00 - 21:00</strong></p>
            </td>
            <td colspan="2">
              <p><strong>星期一至星期五</strong></p>
              <p><strong>Mondays</strong><strong> to Fridays</strong></p>
              <p><strong>18:00 - 21:00</strong></p>
            </td>
          <td style="height: 62px;" colspan="1" rowspan="2">
            <p>13:00-21:00</p>
          </td>
          <td style="height: 133px; text-align: left;" rowspan="2" colspan="4">
            <ol>
              <li>
                使用者必須穿著整齊運動服<br>
                Users must be in appropriate sports attires
              </li>
              <li>
                每個網球場最多容納4人<br>
                Each Tennis Court maximum capacity of 4 persons<br />
              </li>
            </ol>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td style="width: 20%;" colspan="2">
            <p>$40 / 小時 hour</p>

          </td>
          <td style="width: 20%;" colspan="2">
            <p>$60 / 小時 hour</p>

          </td>
        </tr>
        <tr style="text-align: center; height: 13px;">
          <td class="pricingTitle" style="height: 13px;" colspan="10"><strong>體育及多用途活動廳 / Multi-purpose Sports Hall</strong></td>
        </tr>
        <tr style="text-align: center; height: 61px;">
          <td style="height: 61px;" colspan="1">
            <p>羽毛球場</p>
            <p>Badminton Court</p>
          </td>
          <td style="height: 61px;" colspan="2">
            <p>$50 / 小時 hour</p>
          </td>
          <td style="height: 61px;" colspan="2">
            <p>$70 / 小時 hour</p>
          </td>
          <td style="height: 61px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
          <td style="height: 133px; text-align: left;" rowspan="2" colspan="4">
            <ol>
              <li>
                使用者必須穿著整齊運動服裝及不脫色運動鞋<br>
                Users must be in appropriate sports attires and wear
              </li>
              <li>
                每個羽毛球場最多容納4人；籃球場最多容納10人<br>
                Each Badminton Court maximum capacity of 4 person;<br />Basketball Court maximum capacity of 10 person&nbsp;
              </li>
            </ol>
          </td>
        </tr>
        <tr style="text-align: center; height: 72px;">
          <td style="height: 72px;" colspan="1">
            <p>籃球場</p>
            <p>Basketball Court</p>
          </td>
          <td style="height: 72px;" colspan="2">
            <p>$190 / 小時 hour</p>
          </td>
          <td style="height: 72px;" colspan="2">
            <p>$250 / 小時 hour</p>
          </td>
          <td style="height: 72px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
        </tr>
<!--        <tr style="text-align: center; height: 99px;">-->
<!--          <td style="height: 99px;" colspan="1">-->
<!--            <p>體育多用途運動場(活動用途)</p>-->
<!--            <p>Multi-purpose Sports Hall (for event purpose)</p>-->
<!--          </td>-->
<!--          <td style="height: 99px;" colspan="4">-->
<!--            <p>$50,000 4 小時 / Hours (只限場租/room only)</p>-->
<!--            <p>$60,000 半天 / Half day*</p>-->
<!--          </td>-->
<!--          <td style="height: 99px;" colspan="1">-->
<!--            <p>09:00-23:00</p>-->
<!--          </td>-->
<!--          <td style="height: 99px; text-align: left;" colspan="4">-->
<!--            <ol>-->
<!--              <li class="p1">-->
<!--                <p>可於一個月前辦理預訂手續</p>-->
<!--                <p>Booking can be made 1 month in advance.</p>-->
<!--              </li>-->
<!--              <li class="p1">預訂時段 / Booking periods:-->
<!--                <ul>-->
<!--                  <li class="p1">09:00-13:00</li>-->
<!--                  <li class="p1">14:00-18:00</li>-->
<!--                  <li class="p1">19:00-23:00</li>-->
<!--                </ul>-->
<!--              </li>-->
<!--              <li class="p1">租金包括以下項目 / Rental fee inclusive:-->
<!--                <ul>-->
<!--                  <li class="p1">地毯地板 / Carpet flooring</li>-->
<!--                  <li class="p1">LED 電視牆 / LED video wall</li>-->
<!--                  <li class="p1">投影機 / Projector</li>-->
<!--                  <li class="p1">屏幕 / Screen</li>-->
<!--                  <li class="p1">舞台廣播系統連無線麥克風 / PA system with wireless mic</li>-->
<!--                  <li class="p1">上網服務機 / WIFI</li>-->
<!--                </ul>-->
<!--              </li>-->
<!--            </ol>-->
<!--          </td>-->
<!--        </tr>-->
        <tr style="text-align: center; height: 13px;">
          <td class="pricingTitle" style="height: 13px;" colspan="10"><strong>多用途活動室 / Multi-function Room</strong></td>
        </tr>
        <tr style="text-align: center; height: 62px;">
          <td style="height: 62px;" colspan="1">
            <p>瑜珈室</p>
            <p>Yoga Room</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$60 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$90 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
          <td style="height: 124px; text-align: left;" rowspan="2" colspan="4">
            <ol>
              <li>
                <p>瑜伽室最多只可容納10人使用</p>
                <p>The maximum capacity of the Yoga Room is 10</p>
              </li>
              <li>
                <p>乒乓球室最多只可容納4人使用</p>
                <p>The maximum capacity of the Table Tennis Room is 4</p>
              </li>
              <li>
                <p>使用者必須穿著適當之運動衣服及不脫色運動鞋</p>
                <p>Users should put on appropriate sports attire and wear non- marking sport rubber-sole shoes.</p>
              </li>
            </ol>
          </td>
        </tr>
        <tr style="text-align: center; height: 62px;">
          <td style="height: 62px;" colspan="1">
            <p>乒乓球室</p>
            <p>Table Tennis Room</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$35 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="2">
            <p>$50 / 小時 hour</p>
          </td>
          <td style="height: 62px;" colspan="1">
            <p>08:00-22:00</p>
          </td>
        </tr>
        <tr style="height: 62px;">
          <td style="text-align: center; height: 62px;" colspan="1">
            <p>燒烤場</p>
            <p>Barbecue Area</p>
          </td>
          <td style="text-align: center; height: 62px;" colspan="2">
            <p>$100 / 3 小時 hours</p>
          </td>
          <td style="text-align: center; height: 62px;" colspan="2">
            <p>$200 / 3 小時 hours</p>
          </td>
          <td style="text-align: center; height: 62px;" colspan="1">
            <p>11:00-22:00</p>
          </td>
          <td style="height: 62px; text-align: left;" colspan="4">
            <p>每個燒烤爐最多只可容納10人使用</p>
            <p>The maximum capacity for each grill is 10.</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <div class="pricingTitle">
        <strong>會所雜項收費</strong>
      </div>
      <div class="pricingTitle">
        <strong>Miscellaneous Charges</strong>
      </div>
      <table border="1" width="100%"  class="pricingContainer">
        <tbody>
        <tr>
          <td width="229">
            <p style="text-align: center;"><strong>用品種類 / Equipment</strong></p>
          </td>
          <td style="text-align: center;" width="260">
            <p><strong>售賣及租借收費 / Sell and Rental Charges </strong></p>
          </td>
          <td style="text-align: center;" width="236">
            <p><strong>遺失及損壞之收費 / Charge of Lost &amp; Damage </strong></p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>羽毛球 Shuttlecock</p>
          </td>
          <td width="260">
            <p>每個港幣$10 / Each</p>
          </td>
          <td width="236">
            <p>-</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>乒乓球 Table Tennis Ball</p>
          </td>
          <td width="260">
            <p>每個港幣$8 / Each</p>
          </td>
          <td width="236">
            <p>-</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>籃球 Basketball</p>
          </td>
          <td width="260">
            <p>免費 Free of Charge</p>
          </td>
          <td width="236">
            <p>每個港幣$250 / Ball</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>羽毛球拍 Badminton Racket</p>
          </td>
          <td width="260">
            <p>免費 Free of Charge</p>
          </td>
          <td width="236">
            <p>每塊港幣$200 / Racket</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>乒乓球拍 Table Tennis Bat</p>
          </td>
          <td width="260">
            <p>免費 Free of Charge</p>
          </td>
          <td width="236">
            <p>每塊港幣$300 / Racket</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>Tennis Ball 網球</p>
          </td>
          <td width="260">
            <p>每筒港幣 $50 / Can</p>
          </td>
          <td width="236">
            <p>-</p>
          </td>
        </tr>
        <tr style="text-align: center;">
          <td width="229">
            <p>Tennis Racket 網球拍</p>
          </td>
          <td width="260">
            <p>免費 Free of Charge</p>
          </td>
          <td width="236">
            <p>每塊港幣$300 / Racket</p>
          </td>
        </tr>
        </tbody>
      </table>
      <p>&nbsp;</p>
      <p>&nbsp;</p>
      <div style="text-align:left;">
        <p><strong><u>備註</u>:</strong></p>
        <ol>
          <li>機場員工會所每日服務時間為早上7時30分至晚上10時30分。</li>
          <li>會員可於使用設施前7天內以先到先得方式經網上預約系統預訂會所設施，並須即時以信用卡付款。付款一經確認後，預訂將不可取消及更改。所有預訂均不得退款及轉讓。</li>
          <li>會員可攜同非會員使用會所設施。除設施收費外，每位非會員須另繳付訪客費20港元。</li>
          <li>會員如需預訂體育及多用途運動廳或燒烤場作公司或私人活動用途，請聯絡會所職員以查詢有關收費及詳請。場地於活動舉行前1個月內接受預訂，並須親臨會所接待處以信用卡或支票付款作實。</li>
          <li>
            <div>會員如擬在體育及多用途運動廳或燒烤場就活動用途安排場地佈置，必須事先通知會所管理人，並須於活動舉行前最少5個工作天遞交場地佈置設計圖，以供審核及批准。</div>
            <div>如未經會所管理人事先批准，會員不得改動場地設施或在場地設置任何額外家具或設備，否則會所管理人有權要求會員即時將有關物件移離場地，甚或至即時終止會員使用場地，而已繳交的款項將不獲退回。</div>
          </li>
          <li>如會所設施因惡劣天氣（例如黑色暴雨警告信號或八號或以上熱帶氣旋警告信號）而關閉，受影響的預訂將獲安排延期。會員可按照設施租用情況作重新預訂，但只限預訂相同場地及時段，而已繳交的款項概不退回。</li>
          <li>會員每次預訂時，最多可預訂3節時段的會所設施。</li>
          <li>會員於使用場地前，請親臨會所接待處出示確認場地預訂的二維碼，以辦理登記手續，並領取入場咭。</li>
          <li>會員最遲須於設施預訂時間開始後15分鐘內辦理登記手續，否則被視為缺席。</li>
          <li>如會員達到3次缺席，將會被暫停會籍一個月。</li>
          <li>機場員工會所有權優先預留各個設施場地作比賽、訓練、活動班、清潔、維修保養或其他活動使用，而不作預先通知。會所作出的預約將優先於個別會員。</li>
          <li>如會所管理人有合理理由認為會員習慣性及／或故意不遵守機場員工會所或其設施的規則和條例，會所有權取消該會員的任何設施預訂。</li>
          <li>入場咭如有遺失或損壞，將須收取手續費。</li>
          <li>以上收費表只供參考，機場員工會所保留不時修改權利而不作另行通知。</li>
          <li>如對設施預訂有任何爭議，會所管理人保留最終決定權。</li>
        </ol>

        <br>
        <p><strong><u>Remarks</u>:</strong></p>
        <ol start="1">
          <li>The HKIA Staff Clubhouse is open daily from 07:30 to 22:30.</li>
          <li>Members can reserve the Clubhouse’s facilities through the online booking system up to 7 days in advance on a first-come, first-serve basis. Payment must be made immediately by credit card. Cancellation or changes to reservation are not allowed once payment has been confirmed. All reservations are non-refundable and non-transferable.</li>
          <li>Members may bring non-member guests to use the Clubhouse’s facilities. In addition to the facility charges, each non-member guest are required to pay an visitor fee of HK$20.</li>
          <li>For advanced booking of Multi-purpose Sports Hall or Barbecue Area for corporate or private event purpose, please contact our Clubhouse staff for the charges and details. Reservations can be made up to one month before the event date, and will be only confirmed upon credit card or cheque payment has been completed at the Clubhouse reception.</li>
          <li>
            <div>Members planning to arrange venue setup in Multi-purpose Sports Hall or Barbecue Area for event are required to inform the Clubhouse manager in advance. A proposed layout plan shall be submitted at least 5 working days before the event date for review and approval.</div>
            <div>Members are not permitted to alter the facilities or place any additional furniture or equipment without prior approval of the Clubhouse manager. Unauthorized alteration may result in the manager requesting the removal of such items or, in some cases, the immediate termination of facility use, no refund will be provided.</div>
          </li>
          <li>If Clubhouse facilities are closed due to adverse weather (e.g. black rainstorm warning signal or tropical cyclone warning signal no.8 or above), all affected reservations will be rescheduled. Members may rebook the same facility and session based on the availability. No refund will be issued for the fee already paid.</li>
          <li>Members may reserve a maximum of 3 time slots for a facility at any one time.</li>
          <li>Before using the facilities, members shall check-in at the Clubhouse reception by presenting the confirmation QR code and obtaining a facility access card.</li>
          <li>Members should check-in for the facilities not later than 15 minutes after the start of the reserved session, otherwise it will be counted as no-show.</li>
          <li>Members who accumulate no-show for 3 times, their membership will be suspended for one month.</li>
          <li>The HKIA Staff Clubhouse reserves the right to allocate the facilities for competition, training, leisure classes, cleansing, maintenance or other activities/events without prior notice. Clubhouse reservation will take precedence over individual reservation by members.</li>
          <li>If the Clubhouse manager has reasonable grounds to believe that a member has habitually and/or intentionally failed to comply with the Rules and Regulations of the HKIA Staff Clubhouse or its facilities, the Clubhouse has right to cancel any reservation of facilities made by the member.</li>
          <li>A handling fee will be charged for a lost or damaged access card.</li>
          <li>The above pricing list is for reference only and is subject to revision from time to time without prior notice.</li>
          <li>All disputes in respect of reservation of facilities shall be referred to the Clubhouse manager, whose decision will be final and conclusive.</li>
        </ol>

      </div>
    </v-container>
  </HkiaraceBannerFrame>
</template>
<script>
import HkiaraceBannerFrame from "@/components/HkiaraceBannerFrame";

export default {
  name: 'PricingInfo',
  components: {HkiaraceBannerFrame}
}
</script>

<style lang="less">


.pricingTitle {
  text-align: left;
  font-size: 20px !important;

}

.clubHouseEnquiryLabel {
  font-size: 22px;
  font-weight: bold;

}

.pricingContainer {
  tbody {
    tr {
      td {
        padding: 10px;
        @media only screen and (max-width: 1200px) {
          font-size: 10px;
          padding: 4px;
        }

        p {
          margin-bottom: 0px !important;
          @media only screen and (max-width: 1200px) {
            font-size: 10px;
          }
        }

        ol {
          margin-bottom: 0px !important;
        }
      }
    }
  }
}


@media only screen and (max-width: 1200px) {

  .pricing-info-content {
    font-size: 12px;

    .col {
      padding-left: 4px !important;
      padding-right: 4px !important;

      .container {
        padding: 4px;
      }
    }
  }

  .pricingTitle {
    font-size: 16px !important;
  }

  .clubHouseEnquiryLabel {
    font-size: 14px;
  }

  .pricingContainer {
    tbody {
      tr {
        td {
          font-size: 10px;
          padding: 4px;

          p {
            font-size: 10px;
          }
        }
      }
    }
  }
}
</style>
